<mat-card class="chart-card line-chart-card-with-controls">
    <mat-card-header>
        <mat-card-title>
            <div class="chart-name-align">
                <ng-container *ngIf="isHost; else tenantChartTitle">
                    {{ 'license_usage_tenant_chart_title' | translate: { interval: (intervalLabel$ | async) } }}
                    <ui-suggest [searchSourceFactory]="tenantsSearchFactory"
                                [defaultValue]="'license_tenant_page_tenant_placeholder' | translate"
                                [value]="defaultTenant"
                                [clearable]="false"
                                [displayCount]="5"
                                (selected)="onTenantSelect($event)"
                                class="tenant-list-select"
                                width="200px">
                    </ui-suggest>
                </ng-container>
                <ng-template #tenantChartTitle>
                    {{ 'license_usage_chart_title' | translate: { interval: (intervalLabel$ | async) } }}
                </ng-template>
            </div>

            <button (click)="loadChart()"
                    [matTooltip]="'chart_refresh' | translate"
                    type="button"
                    mat-icon-button>
                <mat-icon>refresh</mat-icon>
            </button>
            <button [matMenuTriggerFor]="transactionChartMenu"
                    [matTooltip]="'chart_time_period' | translate"
                    type="button"
                    mat-icon-button>
                <mat-icon svgIcon="uipath:More"></mat-icon>
            </button>
            <mat-menu #transactionChartMenu="matMenu"
                      [overlapTrigger]="false">
                <ng-container *ngLet="(chartInterval$ | async) as chartInterval">
                    <button *ngFor="let interval of defaultUsageIntervals"
                            [class.active]="chartInterval == interval.value"
                            (click)="onIntervalChange(interval.value)"
                            type="button"
                            mat-menu-item>
                        {{ interval.translationKey | translate }}
                    </button>
                </ng-container>
            </mat-menu>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="chart-content">
        <ng-container *uiContentLoading="chart.loading">
            <ui-line-chart *ngIf="chart.hasData; else noChartData"
                           [legend]="chart.legend"
                           [colors]="chart.colors"
                           [data]="chart.data"
                           [fillAreasBelowLines]="true"
                           [smooth]="true"
                           [xAxisLabels]="chart.labels"
                           [tooltipTrigger]="ChartTooltipTrigger.Axis"
                           [showXAxisTickLines]="true"
                           [markMaxPointPerDataset]="true">
            </ui-line-chart>
            <ng-template #noChartData>
                <div *ngIf="!chart.hasData && !chart.loading"
                     class="no-chart-message-container"
                     role="alert">
                    <div translate
                         class="no-chart-message">
                        no_data_general
                    </div>
                </div>
            </ng-template>
        </ng-container>
    </mat-card-content>
</mat-card>
